import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import { MoneyUpdateEdit } from "features/ms6/core/ms6.param";
import {
  updateEditSvrResponse,
  updateEditSvrRepository,
} from "features/ms6/data/ms6.repository";

export enum UpdateEditSvrState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: UpdateEditSvrState;
  message: string;
}

const initialState: InitialState = {
  status: UpdateEditSvrState.initial,
  message: "",
};

export const updateEditSvr = createAsyncThunk(
  "updateEditSvr",
  async (param: MoneyUpdateEdit, { rejectWithValue }) => {
    try {
      const response: updateEditSvrResponse = await updateEditSvrRepository(
        param
      );
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const updateEditSvrSlice = createSlice({
  name: "updateEditSvr",
  initialState,
  reducers: {
    resetupdateEditSvr: (state) => {
      state.status = UpdateEditSvrState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateEditSvr.pending, (state) => {
        state.status = UpdateEditSvrState.inProgress;
      })
      .addCase(updateEditSvr.fulfilled, (state, action) => {
        if (action.payload) {
          const { message } = action.payload;
          state.status = UpdateEditSvrState.success;
          state.message = message;
        }
      })
      .addCase(updateEditSvr.rejected, (state, action) => {
        state.status = UpdateEditSvrState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectupdateEditSvr = (state: RootState) => state.updateEditSvr;
export const { resetupdateEditSvr } = updateEditSvrSlice.actions;
export default updateEditSvrSlice.reducer;
